import { VERIFY_STEPS } from "../flow/steps";
import { useT } from "../i18n";

type Status = "pending" | "active" | "done";

const FACE: Record<Status, string> = {
  done: "😊",
  active: "✨",
  pending: "🙂",
};

export function VerifyStepList({
  statuses,
}: {
  statuses: Record<(typeof VERIFY_STEPS)[number]["id"], Status>;
}) {
  const t = useT();

  return (
    <ol className="verify-steps">
      {VERIFY_STEPS.map((step, i) => {
        const status = statuses[step.id];
        return (
          <li
            key={step.id}
            className={`verify-steps__item verify-steps__item--${status}${
              status === "active" ? " is-active" : ""
            }${status === "done" ? " is-done" : ""}`}
          >
            <span className="verify-steps__num" aria-hidden>
              {status === "done" ? "✓" : i + 1}
            </span>
            <div className="verify-steps__copy">
              <h3>
                <span className="verify-steps__face" aria-hidden>
                  {FACE[status]}
                </span>{" "}
                {t(`verify.steps.${step.id}.title`)}
              </h3>
              <p>{t(`verify.steps.${step.id}.description`)}</p>
            </div>
            <span className="verify-steps__state">
              {status === "done" ? "Complete" : status === "active" ? "Now" : "Next"}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
